import ObsClient from 'esdk-obs-browserjs'
// 华为云上传 key=随机生成名  SourceFile上传地址  name=文件原本名  index=上传的是当前类型的第几个  
// ak ,sk,endpoint,bucketName,prevUrl 均为华为云上传参数
function HUAWEIYUNFun(SourceFile, name, index, callback) {
	console.log('执行封装方法！')

	// var endpoint = sessionStorage.getItem('endpoint');
	// var ak = sessionStorage.getItem('ak');
	// var sk = sessionStorage.getItem('sk');
	// var bucketName = sessionStorage.getItem('bucketName');
	// var prevUrl = sessionStorage.getItem('prevUrl');

	var endpoint = 'obs.cn-north-4.myhuaweicloud.com'
	var ak = '2MGA99DU1PM8C1UDY5GZ'
	var sk = 'IKXmFO0xhLi2kcXqTNpi4LJjWYn0Lg5ov8a2hm1k'
	var bucketName = 'job-consult'
	var prevUrl = 'https://job-consult-hwy.posedu.com.cn/'

	// 生成16位随机数
	var randomStr = randomString(16, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
	var Key = randomStr + '.' + name.split('.')[name.split('.').length - 1]
	let new_url = ''
	let obsClient_put = new ObsClient({
		access_key_id: ak,
		secret_access_key: sk,
		server: endpoint
	});
	// 创建下载实例
	let obsClient_get = new ObsClient({
		access_key_id: ak,
		secret_access_key: sk,
		server: prevUrl
	});
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();

	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var getdateStr = year + "/" + month + "/" + strDate + "/";
	let percent = 0;

	// 获取上传进度
	var callback = function (transferredAmount, totalAmount, totalSeconds) {
		// 获取上传平均速率（KB/S）
		console.log((transferredAmount * 1.0) / totalSeconds / 1024);
		// 获取上传进度百分比
		percent = parseInt(Number((transferredAmount * 100) / totalAmount));
		console.log("进度", percent);
		sessionStorage.setItem('percent',percent);//存入缓存
	};
	// 上传
	return new Promise(function (resolve) {
		obsClient_put.putObject({
			Bucket: bucketName,
			Key: getdateStr + Key,
			ProgressCallback: callback,
			SourceFile: SourceFile // localfile为待上传的本地文件路径，需要指定到具体的文件名
		}, (err, result) => {
			if (err) {
				// 上传失败
				console.error('Error-->' + err);
			} else {
				// 上传成功
				console.log("Key", Key)
				console.log('Status-->' + result.CommonMsg.Status);
				console.log('Status--> 成功', result);

				let bucketName = 'tracesource';
				let objectKey = getdateStr + Key;
				console.log("objectKey", objectKey);
				sessionStorage.setItem('objectKey',objectKey);//存入缓存
				let method = 'GET';
				let res = obsClient_get.createSignedUrlSync({
					Method: method,
					Bucket: bucketName,
					Key: objectKey,
					Expires: 3600
				});
				console.log("res上传后", res);
				// new_url = res.SignedUrl.toString();
				// new_url = prevUrl + new_url.substring(new_url.indexOf(
				// 	objectKey), new_url.length);
				new_url = prevUrl + objectKey;
				console.log('Creating object using url:' + new_url);
				resolve(new_url)
			}
		});
	})


}
//  随机生成字符串
function randomString(length, chars) {
	// console.log("result随机生成字符串1", length, chars)
	var result = '';
	for (var i = length; i > 0; --i) {
		result += chars[Math.floor(Math.random() * chars.length)];
		// console.log("result随机生成字符串", result)
	}
	return result;
}

export default {
	HUAWEIYUNFun: HUAWEIYUNFun,
}


// WEBPACK FOOTER //
// ./src/common/HUAWEIYUN.js


// WEBPACK FOOTER //
// ./src/common/HUAWEIYUN.js